import React, { useEffect, useMemo, useState } from "react";
import * as motion from "motion/react-client";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import BoxPoeple from "./BoxPoeple";
import BoxTarget from "./BoxTarget";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

export const Targeted = ({ trueData, falseData, camera }) => {
  const targetIsDpo = useSelector((state) => state.targetIsDpo.data || []);
  const target = useSelector((state) => state.target.data || []);

  const sortedDataIsDpo = useMemo(() => {
    return [...targetIsDpo].sort(
      (a, b) => (b.similarity || 0) - (a.similarity || 0)
    );
  }, [targetIsDpo]);

  const sortedData = useMemo(() => {
    return [...target].sort(
      (a, b) => (b.similarity || 0) - (a.similarity || 0)
    );
  }, [target]);

  const itemsTarget = sortedDataIsDpo?.map((item) => {
    return (
      <>
        <BoxTarget item={item} nomer="1" color="red" />
      </>
    );
  });
  const itemsPoeple = sortedData?.map((item) => {
    return <BoxPoeple item={item} nomer="1" color="blue" />;
  });
  // console.log(falseData, "trueData");
  return (
    <div>
      {camera?.device_name !== "" ? (
        <div>
          <div>
            <div>
              <motion.div
                initial={{ opacity: 0, x: 50 }} // Mulai dari kanan (+50px)
                animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
                transition={{
                  duration: 0.6, // Lebih cepat (0.6 detik)
                  ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
                }}
                className="flex justify-between "
              >
                <Typography
                  variant="body1"
                  // color=""
                  gutterBottom
                  sx={{ display: "block" }}
                >
                  Target Terdeteksi
                </Typography>
                <div className="animate-shake">
                  <NotificationsActiveIcon />
                </div>
              </motion.div>
            </div>
            <div className="max-h-96 overflow-y-auto space-y-2 ">
              {itemsTarget?.length === 0 ? (
                <motion.div
                  initial={{ opacity: 0, x: 50 }} // Mulai dari kanan (+50px)
                  animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
                  transition={{
                    duration: 0.6, // Lebih cepat (0.6 detik)
                    ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
                  }}
                  className="flex justify-center m-10"
                >
                  {" "}
                  <Typography
                    variant="caption"
                    // color=""
                    gutterBottom
                    sx={{ display: "block" }}
                  >
                    Belum Terdeteksi
                  </Typography>
                </motion.div>
              ) : (
                <div className="p-1">{itemsTarget}</div>
              )}
            </div>
          </div>
          <div>
            <motion.div
              initial={{ opacity: 0, x: 50 }} // Mulai dari kanan (+50px)
              animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
              transition={{
                duration: 0.6, // Lebih cepat (0.6 detik)
                ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
              }}
              className="flex justify-between mt-2 "
            >
              <Typography
                variant="body1"
                // color=""
                gutterBottom
                sx={{ display: "block" }}
              >
                Orang Dikenali
              </Typography>
              <div>
                <NotificationsActiveIcon />
              </div>
            </motion.div>
            <div className="max-h-96 overflow-y-auto space-y-2 ">
              {itemsPoeple?.length === 0 ? (
                <motion.div
                  initial={{ opacity: 0, x: 50 }} // Mulai dari kanan (+50px)
                  animate={{ opacity: 1, x: 0 }} // Bergerak ke posisi normal
                  transition={{
                    duration: 0.6, // Lebih cepat (0.6 detik)
                    ease: [0.33, 1, 0.68, 1], // Bezier untuk transisi smooth tapi cepat
                  }}
                  className="flex justify-center m-10"
                >
                  {" "}
                  <Typography
                    variant="caption"
                    // color=""
                    gutterBottom
                    sx={{ display: "block" }}
                  >
                    Belum Terdeteksi
                  </Typography>
                </motion.div>
              ) : (
                <div className="p-1">{itemsPoeple}</div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="">
          <div>
            <div className="flex justify-between mt-2 ">
              <Typography
                variant="body1"
                // color=""
                gutterBottom
                sx={{ display: "block" }}
              >
                Terdeteksi
              </Typography>
              <div>
                <NotificationsActiveIcon />
              </div>
            </div>
          </div>
          <div className="text-center">Data Kosong</div>
        </div>
      )}
    </div>
  );
};
